import React from "react";
import { Col, Row } from "react-bootstrap";
import {
  SiGit,
  SiGithub,
  SiIntellijidea,
  SiVisualstudiocode,
  SiPostman,
  SiDocker,
  SiJenkins,
  SiLinux,
  SiWireshark,
  SiVmware,
} from "react-icons/si";

const tools = [
  { label: "Git", icon: <SiGit /> },
  { label: "GitHub", icon: <SiGithub /> },
  { label: "IntelliJ IDEA", icon: <SiIntellijidea /> },
  { label: "VS Code", icon: <SiVisualstudiocode /> },
  { label: "Postman", icon: <SiPostman /> },
  { label: "Docker", icon: <SiDocker /> },
  { label: "Jenkins", icon: <SiJenkins /> },
  { label: "Linux", icon: <SiLinux /> },
  { label: "Wireshark", icon: <SiWireshark /> },
  { label: "VMware", icon: <SiVmware /> },
];

function Toolstack() {
  return (
    <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
      {tools.map((item) => (
        <Col xs={4} md={2} className="tech-icons" key={item.label}>
          {item.icon}
          <div className="tech-label">{item.label}</div>
        </Col>
      ))}
    </Row>
  );
}

export default Toolstack;
